import storage from 'utils/sessionStorage';
import { ILockBreakTimeItem, ILockBreakTimeSyncItem } from '../services/types/lockBreakTime';

/**
 * Map a raw appointment-detail block item (from getAppointmentMasterData or the
 * makeLockTime response) into the ILockBreakTimeItem shape stored in state.
 * The lockBreakTimes interface differs from the appointment list, so this
 * mapping bridges the two. The optional `action` is preserved so the result can
 * be fed into syncDataSocket for ADD/UPDATE/REMOVE reconciliation.
 */
export const mapAppointmentDetailToLockBreakTime = (
  item: ILockBreakTimeSyncItem
): ILockBreakTimeItem => ({
  id: item.blockId || '',
  shopId: storage.shop_id.get(),
  staffId: item.staffId,
  startTime: item.startTime,
  endTime: item.endTime,
  type: item.typeBlock || '',
  reason: item.note || '',
  action: item.action,
});
